<template>
    <div class="ManageAccount">
        <h1>
            <v-icon
                v-if="screen_width > 335"
                x-large
                elevation="10"
                class="white--text"
                style="height: 50px; width: 50px; background-color: #009688; border-radius: 25px; margin-right: 2%;"
            >
                {{ mdiAccountCog }}
            </v-icon>
            <span>Manage Account</span>
        </h1>
        <v-alert
            v-model="notif.show"
            transition="scroll-x-reverse-transition"
            class="alertNotif"
            :color="notif.type"
            :type="notif.type"
        >
            {{ notif.msg }}
        </v-alert>
        <v-card class="manageAccountBody">
            <v-text-field
                label="Name"
                :value="getUserInfoData.data.NAME"
                color="#009688"
                outlined
                :prepend-inner-icon="mdiHospitalBuilding"
                readonly
                autocomplete="nope"
            />
            <v-text-field
                label="Email"
                :value="getUserInfoData.data.EMAIL"
                color="#009688"
                outlined
                :prepend-inner-icon="mdiEmail"
                readonly
                autocomplete="nope"
            />
            <v-btn
                style="display: block; max-width: 250px; background-color: #009688; color: white;"
                class="white--text"
                @click="showPass = !showPass"
            >
                <v-icon>{{ mdiLock }}</v-icon> Change password
            </v-btn>
            <ChangePassword
                :show="showPass"
                @closeChangePass="showPass = false"
                @msgChangePass="msgChangePass"
            />
        </v-card>
    </div>
</template>

<script>
import ChangePassword from './FormChangePass.vue'
import { mapActions, mapGetters } from 'vuex'
import {
    mdiAccountCog,
    mdiHospitalBuilding,
    mdiEmail,
    mdiLock
} from '@mdi/js'
export default {
    components: {
        ChangePassword
    },
    data: ()=>({
        mdiAccountCog,
        mdiHospitalBuilding,
        mdiEmail,
        mdiLock,
        notif: {
            msg: '',
            show: false,
            type: null
        },
        showPass: false,
        screen_width: document.documentElement.clientWidth + 9
    }),
    computed: {
        ...mapGetters(['accountCred', 'getUserInfoData'])
    },
    watch: {
        getUserInfoData(newVal) {
            if (newVal) {
                // console.log('getUserInfoData newVal: ', newVal)
            }
        }
    },
    async created() {
        // await this.getCsrfToken()
        this.getUserInfo()
    },
    mounted(){
        window.addEventListener('resize', this.onResize)
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        ...mapActions(['getCsrfToken', 'getAccountDetails', 'getUserInfo']),
        toTitleCase(str) {
            return str.toUpperCase()
        },
        msgChangePass(data) {
            if (data.status!==200) {
                this.notif.type     = 'error'
                this.notif.msg      = data.state
            } else {
                this.notif.type     = 'success'
                this.notif.msg      = 'Password Updated Successfully!'
            }
            this.notif.show = true
            setTimeout(()=>{ this.notif.show = false }, 3000)
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            this.screen_width = this.screen_width + 9
        }
    }
}
</script>

<style scoped>
h1 {
    font-size: 25px;
    padding: 10px;
    border-bottom: 1px solid #bbb;
}
.manageAccountBody {
    margin-top: 5%;
    padding: 3%;
}
.alertNotif {
    position: fixed;
    top: 30;
    right: 7.5%;
    z-index: 999;
}
.ManageAccount {
    padding: 10px 7.5% 0 7.5%;
}
@media (max-width: 380px) {
  .ManageAccount {
    padding: 70px 7.5% 0 7.5%;
  }
  .alertNotif {
    position: fixed;
    top: 10px;
    right: 6%;
    z-index: 999;
  }
}
@media (max-width: 599px) {
  .ManageAccount {
    padding: 70px 7.5% 0 7.5%;
  }
  .alertNotif {
    position: fixed;
    top: 80px;
    right: 6%;
    z-index: 999;
  }
}
@media (min-width: 599px) and (max-width: 1264px) {
  .ManageAccount {
    padding: 70px 7.5% 0 7.5%;
  }
  .alertNotif {
    position: fixed;
    top: 80px;
    right: 7.5%;
    z-index: 999;
  }
}
@media (min-width: 1264px) {
  .ManageAccount {
    padding: 10px 7.5% 0 7.5%;
  }
  .alertNotif {
    position: fixed;
    top: 20px;
    right: 6%;
    z-index: 999;
  }
}
</style>
